import { render, staticRenderFns } from "./InboxBadge.vue?vue&type=template&id=1e751d6a&scoped=true&"
import script from "./InboxBadge.vue?vue&type=script&lang=ts&"
export * from "./InboxBadge.vue?vue&type=script&lang=ts&"
import style0 from "./InboxBadge.vue?vue&type=style&index=0&id=1e751d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e751d6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e751d6a')) {
      api.createRecord('1e751d6a', component.options)
    } else {
      api.reload('1e751d6a', component.options)
    }
    module.hot.accept("./InboxBadge.vue?vue&type=template&id=1e751d6a&scoped=true&", function () {
      api.rerender('1e751d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Account/view/vue/components/InboxBadge.vue"
export default component.exports